import styled from 'styled-components';
import { StyledPageMenuLinkProps } from './PageMenuLink.types';

export const StyledPageMenuLink = styled.div<StyledPageMenuLinkProps>`
  .page-menu-link__slot-wrapper {
    padding: 0;
    border-style: none;
    background-color: transparent;
    cursor: pointer;
  }

  ${(props) => props.customStyle}
`;
